import { Flex, Spinner, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

type LoadingProps = {
  children?: ReactNode;
};

export const Loading = ({ children = 'Carregando...' }: LoadingProps) => {
  return (
    <Flex
      w="100vw"
      h="100vh"
      justify="center"
      align="center"
      gap="1rem"
      flexDir="column"
    >
      {children}
      <Spinner
        thickness="6px"
        speed="0.65s"
        emptyColor="#FF5000"
        color="#FFFFFF"
        size="xl"
      />
    </Flex>
  );
};
